import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Button } from "semantic-ui-react";
import Loader from "../../../components/Loader";
import { abilitiesSelector } from "../../../selectors/user";
import { getParentPageHref } from "../../../utils/routeHelpers";
import LayoutOverlay from "../../../components/LayoutOverlay";
// eslint-disable-next-line
import styles from "./AddBoxUnits.module.css";
import BoxUnitsForm from "./BoxUnitsForm";
import { getBoxUnitById } from "../../../actions/BoxUnits/boxUnits";

class AddBoxUnits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: true,
      boxUnit: null,
    };
    this.boxUnitForm = React.createRef();
  }
  async componentWillMount() {
    const { match } = this.props;
    const { id } = match.params;
    if (id) {
      this.getboxUnit(id);
    } else {
      this.setState({
        isFetching: false,
      });
    }
  }

  getboxUnit = (id) => {
    const {
      actions: { getBoxUnitById },
    } = this.props;
    this.setState({
      isFetching: true,
    });

    getBoxUnitById(id)
      .then((boxUnit) => {
        this.setState({
          isFetching: false,
          boxUnit,
        });
      })
      .catch((error) => {
        if (error.response.status === 404) {
          this.props.navigate("/404");
        }
        this.setState({
          isFetching: false,
        });
      });
  };

  async componentDidUpdate(prevProps, prevState) {
    const { match } = this.props;
    const { id } = match.params;

    if (id && id !== prevProps.match.params.id) {
      this.getboxUnit(id);
    }
  }

  doSubmitForm = () => {
    if (this.boxUnitForm.current) {
      this.boxUnitForm.current.submit();
    }
  };

  render() {
    const { boxUnit, isFetching } = this.state;
    const { route, match, Can, navigate } = this.props;
    const { id } = match.params;
    return (
      <LayoutOverlay
        closeLink={getParentPageHref(route)}
        route={{
          ...route,
          name: id ? route.name.replace("Add", "Edit") : route.name,
        }}
        childrenOnly
        footer={
          <div className={styles.buttonsFooter}>
            {boxUnit && boxUnit.id ? (
              <Can I="update" a="box_units">
                <Button primary size="large" onClick={this.doSubmitForm}>
                  Save
                </Button>
              </Can>
            ) : (
              <Can I="add" a="box_units">
                <Button primary size="large" onClick={this.doSubmitForm}>
                  Save
                </Button>
              </Can>
            )}
          </div>
        }
      >
        {isFetching ? (
          <Loader />
        ) : (
          <BoxUnitsForm
            navigate={navigate}
            initialValues={boxUnit}
            formRef={this.boxUnitForm}
          />
        )}
      </LayoutOverlay>
    );
  }
}

AddBoxUnits.propTypes = {
  route: PropTypes.object.isRequired,
  boxUnit: PropTypes.object,
  match: PropTypes.object,
  actions: PropTypes.object,
  Can: PropTypes.func,
};

AddBoxUnits.defaultProps = {
  route: { name: "{%name%}" },
};

const mapStateToProps = (state) => {
  return {
    Can: abilitiesSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ getBoxUnitById }, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddBoxUnits);
